// extracted by mini-css-extract-plugin
export default {"project":"project_project__Q85Jo","projectContent":"project_projectContent__JKMsC","yakOfficeLogo":"project_yakOfficeLogo__EnCSl"};